import {useCallback, useEffect, useState} from 'react';
import * as RecentKeywordListStorage from './recentKeywordList.storage';

export function useRecentSearchKeyword(autoSaveRecentKeyword: boolean) {
  const [recentKeywordList, setRecentKeywordList] = useState<
    RecentKeywordListStorage.RecentSearchKeyword[]
  >([]);

  useEffect(() => {
    const _recentKeywordList = RecentKeywordListStorage.getRecentKeywordList();
    if (!_recentKeywordList || !autoSaveRecentKeyword) {
      return;
    }
    setRecentKeywordList(_recentKeywordList);
  }, [autoSaveRecentKeyword]);

  const removeAllRecentKeyword = useCallback(() => {
    setRecentKeywordList([]);
    RecentKeywordListStorage.clearRecentKeywordList();
  }, []);

  const removeRecentKeyword = useCallback((keyword: string) => {
    RecentKeywordListStorage.removeRecentKeyword(keyword);
    setRecentKeywordList(RecentKeywordListStorage.getRecentKeywordList() || []);
  }, []);

  return {
    recentKeywordList,
    setRecentKeywordList,
    removeAllRecentKeyword,
    removeRecentKeyword,
  };
}
